function throttle<T extends (...args: any[]) => void>(fn: T, ms: number): T & { cancel: () => void } {
    let last = 0;
    let timer: number | null = null;
    let lastArgs: any[] | null = null;

    const throttled = function (this: any, ...args: any[]): any {
        const now = Date.now();
        const remaining = ms - (now - last);
        lastArgs = args;

        if (remaining <= 0) {
            last = now;
            fn.apply(this, args);
            return;
        }

        if (timer !== null) {
            return;
        }

        timer = window.setTimeout((): any => {
            timer = null;
            last = Date.now();
            if (lastArgs) {
                fn.apply(this, lastArgs);
                lastArgs = null;
            }
        }, remaining);
    } as T & { cancel: () => void };

    // Cancels a pending trailing call so callers can flush a final state themselves.
    throttled.cancel = function (): void {
        if (timer !== null) {
            window.clearTimeout(timer);
            timer = null;
        }

        lastArgs = null;
    };

    return throttled;
}

// ----------------------------------------------------------------------------

export default throttle;
